export default __webpack_public_path__ + "static/media/repairing.597df25a.gif";